module.exports = __webpack_public_path__ + "img/ouvidoria-banner.5442bc1d.png";